module.exports = __webpack_public_path__ + "static/media/pnglogo.a87f43c6.png";